import { useState } from "react";
import { selectCommunicationData } from "../../store";
import { useAppSelector } from "../../store/hooks";
import { FileItemType } from "../../types/communication/communicationDataType";
import FotoMultiConfirmSection from "../foto-multi-confirm-section/FotoMultiConfirmSection";
import { Section } from "../styled/Containers.style";
import cruscotto_img from './../../assets/img/cruscotto.png'
import { LiqPhotoTypeMapper, PhotoTypeEnum } from "../../types/commonTypes";

const TOT_FOTO_CRUSCOTTO = 1

export interface FotoCruscottoProps {
    onTotFotoIsRiched: any
}

/* istanbul ignore next */
const FotoCruscotto = ({ onTotFotoIsRiched }: FotoCruscottoProps) => {
    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData
    const [fotoCruscotto, setFotoCruscotto] = useState<FileItemType[]>(communication.fotoCruscotto)
    const fotoPresent = fotoCruscotto?.length > 0

    return (
        <>
            {!fotoPresent && <Section>
                <img src={cruscotto_img}
                    alt="cruscotto" />
            </Section>}
            <FotoMultiConfirmSection
                fileType={PhotoTypeEnum.CRUSCOTTO_DOCS}
                additionalBeInfo={{
                    liqDocumentType: LiqPhotoTypeMapper[PhotoTypeEnum.CRUSCOTTO_DOCS],
                    liqDescription: "Foto cruscotto"
                }}
                files={fotoCruscotto}
                setFiles={setFotoCruscotto}
                arrayDbPropSync={"fotoCruscotto"}
                textLabel={"Scatta foto"}
                titleImageDetail={"Foto del cruscotto"}
                totPhotosForStepDone={TOT_FOTO_CRUSCOTTO}
                onTotFotoIsRiched={onTotFotoIsRiched}
            />
        </>
    )
}

export default FotoCruscotto